import { Component } from '@angular/core';
import { soundpostGLAccountMappingEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'GL Account Mappings') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-soundpostglaccountmapping-form',
    templateUrl: './soundpostglaccountmapping.form.component.html'
})
export class soundpostGLAccountMappingFormComponent extends BaseFormComponent {
    public record!: soundpostGLAccountMappingEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true }
        ]);
    }
}

